module.exports = __webpack_public_path__ + "media/images/leads_generation/organization-info-5b6e261109629c4e98c4ca58e5234c99.svg";